'use strict';

angular.module('randomization')
    .controller('RandomizationCohortController', ['gettextCatalog', 'SitesService', '$q', 'CrfService', function(gettextCatalog, SitesService, $q, CrfService) {
        var vm = this;

        vm.info = [];

        // Datos de los centros para sacar el label
        var _availableSites = null;

        // Datos de los campos que pueden aparecer en la cohorte, indexados por ID de campo
        var _fields = {};

        vm.$onChanges = _setInfo;

        function _setInfo() {
            vm.info = [];

            angular.forEach(vm.data, function(value, field) {
                var promise;

                if (field === 'site') {
                    promise = _getSiteValue(value)
                        .then(function(siteValue) {
                            return {
                                label: gettextCatalog.getString('Centro', {}, 'sites'),
                                fullLabel: gettextCatalog.getString('Código de centro', {}, 'sites'),
                                value: siteValue,
                            };
                        });
                } else { // es un campo
                    promise = _getFieldData(field, value);
                }

                return promise.then(function(info) {
                    vm.info.push(info);
                });
            });
        }

        function _getSiteValue(siteId) {
            var promise;

            if (_availableSites === null) {
                _availableSites = {};

                promise = SitesService.list()
                    .then(function(sites) {
                        angular.forEach(sites.data, function(siteData) {
                            _availableSites[siteData.id] = siteData;
                        });
                    });
            } else {
                promise = $q.resolve();
            }

            return promise.then(function() {
                if (angular.isDefined(_availableSites[siteId])) {
                    var cosa = _availableSites[siteId].name + ' (' + _availableSites[siteId].code + ')';

                    return cosa;
                }

                return siteId;
            });
        }

        function _getFieldData(fieldId, fieldValue) {
            if (angular.isUndefined(_fields[fieldId])) {
                _fields[fieldId] = CrfService.getField(fieldId);
            }

            var field = _fields[fieldId];

            if (field === null) {
                return $q.resolve({
                    label: gettextCatalog.getString('Campo {{id}}', {id: fieldId}, 'crf fields'),
                    fullLabel: gettextCatalog.getString('El campo ya no existe en la estructura'),
                    value: fieldValue,
                });
            }

            return $q.resolve({
                label: field.getLabel(),
                fullLabel: field.getFullLabel().join(' > '),
                value: field.getReadableValue(fieldValue),
            });
        }
    }]);
